const ASSETS_URL_TEMPLATE = 'https://assets.unknownkind.com';

export function getURL(fileName: string) {
  return `${ASSETS_URL_TEMPLATE}/${fileName}`;
}
